// New values should be in camelCase
export enum EventTypes {
    REALITY_CHECK = 'reality_check',
    BALANCE_CHECK = 'balance_check',
    // TODO deprecated, remove. Use "SCROLL_TO" instead
    IFRAME_TOP = 'iframeTop',
    SCROLL_TO = 'scroll_to',
    // TODO deprecated, remove. Use "WINDOW_DATA" instead
    PAGE_Y_OFFSET = 'getPageYOffset',
    NEW_RESIZE = 'new_resize',
    NEW_HEIGHT = 'betgames_new_height',
    SET_THEME = 'setThemeStyles',
    THEME_READY = 'themeEditorReady',
    HOME_BUTTON_CLICK = 'home_button_click',
    GAME_NAVIGATION = 'gameNavigation',
    FULL_SCREEN = 'fullscreen',
    LOBBY = 'lobby',
    WINDOW_DATA = 'windowData',
    SUBSCRIBE_WINDOW_RESIZE = 'subscribeWindowResize',
    UNSUBSCRIBE_WINDOW_RESIZE = 'unsubscribeWindowResize',
}
